
import config from './config'

export default {actionTypes: {
        UPDATE_USER_TYPE: 'UPDATE_USER_TYPE',
        UPDATE_USER_ID: 'UPDATE_USER_ID'
    }, config}
